import { CompositeLayer } from '@deck.gl/core';
import { PolygonLayer } from '@deck.gl/layers';
import { polygonHull } from 'd3-polygon';

class ThreatZoneOverlay extends CompositeLayer {
    static layerName = 'ThreatZoneOverlay';

    static defaultProps = {
        data: [],
        visible: true
    };

    initializeState() {
        this.setState({
            hull: []
        });
    }

    updateState({ props, changeFlags }) {
        if (changeFlags.dataChanged) {
            const threatPoints = (props.data || [])
                .filter(d => d.threat_detected === 'Yes' && d.lat != null && d.lon != null)
                .map(d => [d.lon, d.lat]);

            if (threatPoints.length >= 3) {
                const hull = polygonHull(threatPoints);
                // polygonHull returns an array of points [x, y], which DeckGL expects as a polygon loop.
                // We wrap it in an array because PolygonLayer expects data to be an array of objects/polygons.
                // If hull is null (e.g. collinear points), we handle it.
                this.setState({ hull: hull ? [hull] : [] });
            } else {
                this.setState({ hull: [] });
            }
        }
    }

    renderLayers() {
        if (!this.props.visible) return [];

        // Animation logic
        // We compute alpha based on current time to create a pulsing effect
        const now = Date.now();
        // 2 seconds cycle (2000ms)
        // progress goes 0 -> 1 cyclically
        const progress = (now % 2000) / 2000;
        // sine wave -1 -> 1
        const t = Math.sin(progress * Math.PI * 2);
        // Map -1..1 to 40..90
        // (t + 1) / 2 is 0..1
        // 40 + (0..1) * 50 = 40..90
        const alpha = 40 + ((t + 1) / 2) * 50;

        // Request a redraw for the next frame to keep animation going
        this.setNeedsRedraw(true);

        const { hull } = this.state;

        if (!hull || hull.length === 0) return [];

        return [
            new PolygonLayer({
                id: `${this.props.id}-polygon`,
                data: hull,
                getPolygon: d => d,
                getFillColor: [239, 68, 68, alpha],
                getLineColor: [239, 68, 68, 200],
                getLineWidth: 2,
                lineWidthMinPixels: 2,
                filled: true,
                stroked: true,
                pickable: true,
                // Critical for performance: only update color when alpha changes (which is every frame, but explicit trigger helps)
                updateTriggers: {
                    getFillColor: [alpha]
                }
            })
        ];
    }
}

export default ThreatZoneOverlay;
